<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="large-dialog"
    :close-on-click-modal="false"
    v-dialogDrag
  >
    <split-line content-position="left">数据源配置</split-line>
    <div>
      <el-form
        :model="dataSourceForm"
        :rules="dataSourceFormRules"
        label-position="right"
        label-width="140px"
        ref="dataSourceFormRef"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="数据源名称" prop="dataSourceName">
              <el-input
                v-model="dataSourceForm.dataSourceName"
                size="small"
                placeholder="请输入"
                :maxlength="25"
                show-word-limit
                :readonly="dialogTitle === '查看'"
                class="dataSourceName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="dbType">
              <el-select
                size="small"
                v-model="dataSourceForm.dbType"
                placeholder="请选择"
                class="w-100"
                :disabled="dialogTitle === '查看'"
              >
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.item2"
                  :value="item.item1"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主机名/IP地址" prop="dataServer">
              <el-input
                v-model="dataSourceForm.dataServer"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dataSourceForm.dbType === 1">
            <el-form-item label="服务名称" prop="serviceName">
              <el-input
                v-model="dataSourceForm.serviceName"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据库名称" prop="dataBase">
              <el-input
                v-model="dataSourceForm.dataBase"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据表名称" prop="tableName">
              <el-input
                v-model="dataSourceForm.tableName"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名" prop="userId">
              <el-input
                v-model="dataSourceForm.userId"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="pwd">
              <el-input
                v-model="dataSourceForm.pwd"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="端口" prop="port">
              <el-input
                v-model="dataSourceForm.port"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目标表代码" prop="destTableCode">
              <el-input
                v-model="dataSourceForm.destTableCode"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目标表名称" prop="destTableName">
              <el-input
                v-model="dataSourceForm.destTableName"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                v-model="dataSourceForm.remark"
                placeholder="请输入"
                :rows="2"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <split-line content-position="left">采集任务配置</split-line>
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务名称" prop="taskName">
              <el-input
                v-model="dataSourceForm.taskName"
                size="small"
                placeholder="请输入"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="频率" prop="taskRate" v-if="environment === 'SAAS'">
              <el-select
                size="small"
                v-model="dataSourceForm.taskRate"
                placeholder="请选择"
                class="w-100"
                :disabled="dialogTitle === '查看'"
                @change="changeTaskRate"
              >
                <el-option
                  v-for="(item, index) in taskRateList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="频率" prop="taskRate" v-if="environment === 'DIY'">
              <el-select
                size="small"
                v-model="dataSourceForm.taskRate"
                placeholder="请选择"
                class="w-100"
                :disabled="dialogTitle === '查看'"
                @change="changeTaskRate"
              >
                <el-option
                  v-for="(item, index) in taskRateList"
                  :key="index"
                  :label="item.displayName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="taskRemark">
              <el-input
                type="textarea"
                v-model="dataSourceForm.taskRemark"
                placeholder="请输入"
                :rows="2"
                :readonly="dialogTitle === '查看'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom_button" slot="footer">
      <el-button
        type="primary"
        size="small"
        @click="saveBtnClick"
        :loading="saveBtnLoading"
        v-if="dialogTitle !== '查看'"
        :disabled="connectionLoading"
        >保存</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="testConnection"
        :loading="connectionLoading"
        v-if="dialogTitle !== '查看'"
        :disabled="saveBtnLoading"
        >测试连接</el-button
      >
      <el-button size="small" @click="dialogVisible = false" v-if="dialogTitle !== '查看'"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import QualityTaskService from '@/services/QualityTaskService'
import MetadataManageService from '@/services/MetadataManageService'

export default {
  name: 'collectionCreate',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: '',
    }, // 弹窗标题
    operateMetadata: {
      type: Object,
      default: () => {
        return {}
      },
    }, // 操作项数据(新增or编辑or查看)
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    environment() {
      return Wiz.GetModuleConfig('legacy-resource').currentEnv.environment
    },
  },
  data() {
    return {
      operation: 1, // 1.新增 2.编辑
      dataSourceForm: {
        dataSourceName: '', // 数据源名称
        dbType: '', // 类型
        dataServer: '', // ip
        dataBase: '', // 数据库名称
        tableName: '', // 数据表名称
        userId: '', // 用户名
        pwd: '', // 密码
        port: '', // 端口
        remark: '', // 备注
        taskName: '', // 任务名称
        taskRate: '', // 频率
        taskRemark: '', // 采集任务配置备注
        cronExpressionValue: '', // cron表达式值
        serviceName: '', // 服务名称
      }, // 数据源配置表单数据
      dataSourceFormRules: {
        dataSourceName: [{ required: true, message: '请输入数据源名称', trigger: 'blur' }],
        dbType: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        dataServer: [{ required: true, message: '请输入主机名/IP地址', trigger: 'blur' }],
        dataBase: [{ required: true, message: '请输入数据库名称', trigger: 'blur' }],
        tableName: [{ required: true, message: '请输入数据表名称', trigger: 'blur' }],
        userId: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        port: [{ required: true, message: '请输入端口', trigger: 'blur' }],
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        taskRate: [{ required: true, message: '请选择频率', trigger: 'change' }],
        serviceName: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
        destTableCode: [{ required: true, message: '请输入目标表代码', trigger: 'blur' }],
        destTableName: [{ required: true, message: '请输入目标表名称', trigger: 'blur' }],
      }, // 数据源配置表单规则
      saveBtnLoading: false, // 保存按钮loading
      connectionLoading: false, // 测试连接按钮loading
      typeList: [], // 类型下拉框
      taskRateList: [], // 频率下拉框
    }
  },
  methods: {
    // 获取类型下拉框数据
    async getDbTypes() {
      const res = await MetadataManageService.getDbTypes()
      if (res && res.code === 0) {
        this.typeList = res.data
      }
    },
    /**
     * @description 修改频率
     */
    changeTaskRate(val) {
      _.map(this.taskRateList, (item) => {
        if (item.id === val) {
          this.dataSourceForm.cronExpressionValue =
            this.environment === 'DIY' ? item.data : item.value
        }
      })
      if (
        this.dataSourceForm.cronExpressionValue === '' ||
        this.dataSourceForm.cronExpressionValue === null
      ) {
        this.$message.warning('CRON表达式无效')
        this.dataSourceForm.taskRate = ''
      }
    },
    /**
     * @function 获取字典
     */
    async getDic(code) {
      const res = await QualityTaskService.getDic({
        code,
      })
      if (res && res.code === 0) {
        return _.head(res.data) || {}
      }
      return {}
    },
    /**
     * @function 获取cron表达式选项列表
     */
    async getCronList() {
      const dic = await this.getDic('CRONEXPRESSION')
      if (!_.isEmpty(dic)) {
        const res = await QualityTaskService.cron({
          skipCount: 0,
          maxResultCount: 999,
          dataCategoryId: dic.id,
        })
        if (res && res.code === 0) {
          this.taskRateList = res.data
        }
      }
    },
    /**
     * @description 获取频率下拉框
     */
    async getTypeList() {
      const res = await MetadataManageService.getTypeList({
        pageno: 1,
        pagesize: 999,
        owner_id: '',
        dic_cate_code: 'CRONEXPRESSION',
      })
      if (res && res.data && res.code === 0) {
        this.taskRateList = res.data
      }
    },

    /**
     * @description 测试连接--验证所填的表是否存在
     */
    async testConnection() {
      this.$refs.dataSourceFormRef.validate(async (valid) => {
        if (valid) {
          this.connectionLoading = true
          const res = await MetadataManageService.testExisttable({
            databaseType: this.dataSourceForm.dbType,
            source: this.dataSourceForm.dataServer,
            port: this.dataSourceForm.port,
            database: this.dataSourceForm.dataBase,
            uid: this.dataSourceForm.userId,
            pwd: this.dataSourceForm.pwd,
            tableName: this.dataSourceForm.tableName,
            serviceName: this.dataSourceForm.serviceName,
          })
          this.connectionLoading = false
          if (res && res.data === true && res.code === 0) {
            this.$message.success('连接成功')
          } else if (res && res.data === false && res.code === 0) {
            this.$message.error('连接失败')
          }
        }
      })
    },

    /**
     * @description 新增or编辑
     */
    async addMatedata() {
      let res = null
      if (this.dialogTitle === '新增') {
        res = await MetadataManageService.createMatedata({
          model: { ...this.dataSourceForm },
        })
      } else {
        res = await MetadataManageService.patchMatedata({
          model: { ...this.dataSourceForm },
        })
      }
      this.saveBtnLoading = false
      if (res && res.data && res.code === 0) {
        this.$message.success('保存成功')
        this.$emit('success')
        this.dialogVisible = false
      }
    },

    /**
     * @description 保存(保存前还要进行一次测试连接操作)
     */
    saveBtnClick() {
      this.$refs.dataSourceFormRef.validate(async (valid) => {
        if (valid) {
          this.saveBtnLoading = true
          const res = await MetadataManageService.testExisttable({
            databaseType: this.dataSourceForm.dbType,
            source: this.dataSourceForm.dataServer,
            port: this.dataSourceForm.port,
            database: this.dataSourceForm.dataBase,
            uid: this.dataSourceForm.userId,
            pwd: this.dataSourceForm.pwd,
            tableName: this.dataSourceForm.tableName,
            serviceName: this.dataSourceForm.serviceName,
          })
          if (res && res.data === true && res.code === 0) {
            this.addMatedata()
          } else if (res && res.data === false && res.code === 0) {
            this.$message.error('连接失败')
            this.saveBtnLoading = false
          }
        }
      })
    },
  },
  created() {
    this.getDbTypes()
    if (this.environment === 'DIY') {
      this.getCronList()
    } else {
      this.getTypeList()
    }
    if (this.dialogTitle !== '新增') {
      this.dataSourceForm = { ...this.operateMetadata }
    }
  },
}
</script>

<style lang="scss" scoped>

.bottom_button {
  display: flex;
  justify-content: center;
}
/deep/ .el-form-item__label {
  text-align: right;
}
.dataSourceName /deep/.el-input__inner {
  padding-right: 50px !important;
}

</style>
